<template>
  <AppModal
    v-model="state.isVisible"
    :title="state.options.title"
    :ok-title="state.options.okTitle"
    :cancel-title="state.options.cancelTitle"
    :z-index="100"
    size="sm"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div class="text-sm text-gray-700">
      {{ state.options.message }}
    </div>

    <template #footer>
      <button
        type="button"
        class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none"
        @click="handleCancel"
      >
        {{ state.options.cancelTitle || 'NO' }}
      </button>
      <button
        type="button"
        :class="[
          'px-4 py-2 text-sm font-medium text-white rounded-md focus:outline-none',
          state.options.variant === 'danger' ? 'bg-red-600 hover:bg-red-700' : 'bg-primary hover:bg-primary-dark'
        ]"
        @click="handleOk"
      >
        {{ state.options.okTitle || 'YES' }}
      </button>
    </template>
  </AppModal>
</template>

<script setup lang="ts">
import { useConfirmDialog } from '@/composables/useConfirmDialog'
import AppModal from './AppModal.vue'

const { state, handleOk, handleCancel } = useConfirmDialog()
</script>

